import React from "react";
import { motion, useCycle } from "framer-motion";

const Spinner = () => {
  const [x, cycleX] = useCycle(360, -360);

  return (
    <div className="center">
      <h4>Spinner</h4>
      <motion.div
        animate={{ rotate: x }}
        transition={{ ease: "linear", duration: 2, loop: Infinity }}
        className="box"
        style={{ backgroundColor: "#845EC2" }}
        onTap={() => cycleX()}
      ></motion.div>
    </div>
  );
};

export default Spinner;
